import React, { useEffect, useState, useRef } from "react";

// Modules
import { useSelector } from "react-redux";

// App
import { getOnlineNode } from "../../core/getNode";
import { postNode } from "../../core/postNode";
import CompanyappLoader from "../../partials/companyappLoader";
import NoData from "../../partials/noData";
import Pagination from "../../partials/pagination";
import { screenOptions, linkGenerator } from "../../utils/helpers";

// UI components
import { Row, Col } from "react-bootstrap";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TextField,
  Typography,
  IconButton,
  Box,
  Alert,
  FormControl,
  InputAdornment,
  InputLabel,
  Select,
  OutlinedInput,
  Input,
  MenuItem,
  Stack,
  ListItemText,
  Tab,
  Tabs,
  Autocomplete,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import SearchOutlined from "@mui/icons-material/SearchOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const pageSize = 20;
const input_font_size = 14;
const input_variant = "outlined";

export default function PushNotifications() {
  // redux
  const user = useSelector((state) => state).authReducer.user;
  const permissions = useSelector((state) => state).permissionsReducer
    .permissions;
  const resetCountRef = useRef(0);
  const [isLoading, setLoading] = useState(true);
  const [isSearching, setSearching] = useState(false);
  const [isError, setError] = useState(false);
  const [errorStatus, setErrorStatus] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");

  const [pushError, setPushError] = useState(null);
  const [pushSuccess, setPushSuccess] = useState(null);
  const [pushSending, setPushSending] = useState(false);

  const [selectedType, setSelectedType] = useState("0");

  const [selectedTokens, setSelectedTokens] = useState({
    users: [],
    categories: [],
    roles: [],
  });
  const [open, setOpen] = useState(false);
  const [toAll, setToAll] = useState(false);
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");

  const [nid, setNid] = useState("");
  const [screen, setScreen] = useState("");
  const [url, setUrl] = useState("");

  const [roles, setRoles] = useState([
    {
      id: "all",
      label: "All roles",
    },
  ]);
  const [categories, setCategories] = useState([
    {
      value: "all",
      label: "All categories",
    },
  ]);

  const [uid, setUid] = useState("");
  const [username, setUsername] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [rolesFilter, setRolesFilter] = useState(["all"]);
  const [categoriesFilter, setCategoriesFilter] = useState(["all"]);

  const [currentPage, setCurrentPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [notifications, setNotifications] = useState([]);
  const [currentNotificationsPage, setCurrentNotificationsPage] = useState(0);
  const [totalNotificationsItems, setTotalNotificationsItems] = useState(0);
  const [totalNotificationPages, setTotalNotificationPages] = useState(0);
  const [notificationsLoading, setNotificationsLoading] = useState(false);
  const [notificationsError, setNotificationsError] = useState(false);

  const [activeView, setActiveView] = useState(0);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [notificationDialog, setNotificationDialog] = useState(false);

  const [data, setData] = useState({
    categories: [],
    roles: [],
    users: [],
  });

  useEffect(() => {
    if (permissions.send_push_notifications) {
      getContent();
    } else {
      setErrorStatus(403);
      setErrorMessage("You do not have permission to access this page.");
      setError(true);
    }
    // eslint-disable-next-line
  }, [currentPage]);

  useEffect(() => {
    getNotifications();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentNotificationsPage]);

  useEffect(() => {
    if (resetCountRef.current > 0) {
      getContent();
      resetCountRef.current = 0; // Reset counter
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, uid, username, name, email, rolesFilter, categoriesFilter]);

  useEffect(() => {
    setUrl(getUrlValue());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screen, nid]);

  useEffect(() => {
    if (activeView === 1) {
      getNotifications();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeView]);

  const onApply = () => {
    setCurrentPage(0);
    getContent();
  };

  const onReset = () => {
    resetCountRef.current += 1;
    setCurrentPage(0);
    setUid("");
    setUsername("");
    setName("");
    setEmail("");
    setRolesFilter(["all"]);
    setCategoriesFilter(["all"]);
  };

  const getContent = () => {
    setSearching(true);

    // Base API path with pagination
    let path = `api/fcm/token/list?items_per_page=${pageSize}&page=${currentPage}`;

    // Add filters dynamically
    const params = new URLSearchParams();

    if (uid && uid !== "all") {
      params.append("uid", uid);
    }

    if (username && username !== "all") {
      params.append("username", username);
    }

    if (email && email !== "all") {
      params.append("email", email);
    }

    if (rolesFilter.length > 0 && rolesFilter[0] !== "all") {
      params.append("roles", rolesFilter.join(","));
    }

    if (categoriesFilter.length > 0 && categoriesFilter[0] !== "all") {
      params.append("categories", categoriesFilter.join(","));
    }

    // Append filters to the path
    if (params.toString()) {
      path += `&${params.toString()}`;
    }

    getOnlineNode(path)
      .then((response) => {
        setLoading(false);
        setSearching(false);

        setData({
          categories: response.data.categories,
          roles: response.data.roles,
          users: response.data.users,
        });
        setTotalItems(response.data.pager.total_items);
        setTotalPages(response.data.pager.total_pages);

        // Add "All roles" to roles list if it's part of the response
        const newRoles = [
          {
            id: "all",
            label: "All roles",
          },
          ...response.data.roles,
        ];
        // Add "All categories" to categories list if it's part of the response
        const newCategories = [
          {
            id: "all",
            label: "All categories",
          },
          ...response.data.categories,
        ];
        setRoles(newRoles);
        setCategories(newCategories);
      })
      .catch((error) => {
        console.log("error: ", error);
        setError(true);

        if (error?.response?.status) {
          setErrorStatus(error.response.status);
        }

        if (error?.response?.statusText) {
          setErrorMessage(error.response.statusText);
        } else {
          setErrorMessage("Failed to fetch tokens. Unknown error!");
        }
      });
  };

  const getNotifications = () => {
    setNotificationsLoading(true);
    setNotificationsError(false);

    const path = `api/fcm/notifications/list?items_per_page=${pageSize}&page=${currentNotificationsPage}`;

    getOnlineNode(path)
      .then((response) => {
        setNotifications(response.data.rows);
        setTotalNotificationsItems(response.data.pager.total_items);
        setTotalNotificationPages(response.data.pager.total_pages);
        setNotificationsLoading(false);
      })
      .catch((error) => {
        console.log("error: ", error);
        setNotificationsLoading(false);
        setNotificationsError(true);
      });
  };

  // Toggle token selection
  const handleToggle = (row, checked) => {
    const { type, id } = row;

    if (toAll) {
      setToAll(false);
    }

    setSelectedTokens((prev) => {
      const updatedList = checked
        ? [...prev[type], id]
        : prev[type].filter((v) => v !== id);

      return {
        ...prev,
        [type]: updatedList,
      };
    });
  };

  // Clear selected tokens
  const handleClear = () => {
    setSelectedTokens({
      users: [],
      roles: [],
      categories: [],
    });
    setToAll(false);
  };

  const handleToAll = () => {
    setSelectedTokens({
      users: [],
      roles: [],
      categories: [],
    });
    setToAll(true);
  };

  // Updated handleSend using postNode
  const handleSend = async () => {
    setPushSending(true);

    const payload = {
      nid: nid,
      screen: screen,
      url: getUrlValue(),
    };

    let requestBody = {
      title,
      body,
      payload,
    };

    // sendToAll if "send to all" tab is active which is 3
    if (selectedType === "3") {
      requestBody.sendToAll = "true";
    } else {
      requestBody.users = selectedTokens.users;
      requestBody.roles = selectedTokens.roles;
      requestBody.categories = selectedTokens.categories;
    }

    try {
      const response = await postNode(
        "api/fcm/push",
        requestBody,
        user.csrf_token
      );

      if (response && response.status === 200) {
        setPushError(null);
        setPushSuccess("Notification sent successfully!");

        // Clear all data upon success
        handleClear();
        setTitle("");
        setBody("");
        setNid("");
        setScreen("");
        setUrl("");
      } else {
        setPushError("Failed to send notification.");
        setPushSuccess(null);
      }
    } catch (error) {
      setPushError("An error occurred while sending the notification.");
      setPushSuccess(null);
    } finally {
      setOpen(false);
      setPushSending(false);
    }
  };

  // No mt-4/pt-4 on the header row: .screen.tokens already sets padding-top
  // 3rem, and those two Bootstrap utilities stacked another 30px margin plus
  // 30px padding on top of it — roughly 120px of dead space above the title.
  // The .push-notifications-header rule owns this row's spacing.
  const renderHeader = () => {
    return (
      <Row className="push-notifications-header gx-0">
        <Col xs={8}>
          <Row className="gx-0">
            <Col xs="auto">
              <Typography className="mb-0" variant="h2" owner="admin">
                Push Notifications
              </Typography>
            </Col>
            <Col xs="auto d-flex align-items-center justify-content-center pt-1">
              <Tooltip
                title={
                  "Please note: details of users who have logged into the system are shown below. However, this does not confirm that the user has granted the app permission to receive push notifications. Therefore, delivery cannot be guaranteed."
                }
                placement="bottom"
              >
                <IconButton size="small" color="adminText">
                  <InfoOutlinedIcon fontSize="inherit" />
                </IconButton>
              </Tooltip>
            </Col>
          </Row>
        </Col>
        <Col xs={4}>
          <Row className="gx-0 justify-content-end toggle-view-btn-container h-100">
            <Col xs="auto">
              <Button
                className={`toggle-btn send ${
                  activeView === 0 ? "active" : ""
                }`}
                onClick={() => setActiveView(0)}
              >
                <Typography owner="admin" variant="button">
                  Send New
                </Typography>
              </Button>
            </Col>
            <Col xs="auto">
              <Button
                className={`toggle-btn sent ${
                  activeView === 1 ? "active" : ""
                }`}
                onClick={() => setActiveView(1)}
              >
                <Typography owner="admin" variant="button">
                  View Sent
                </Typography>
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  };

  const renderTabs = () => {
    return (
      <Row className="justify-content-center">
        <Col>
          <Tabs
            value={selectedType}
            onChange={(event, newValue) => {
              setSelectedType(newValue);
              if (toAll && newValue !== "3") {
                handleClear();
              }
            }}
            aria-label="Token List"
          >
            <Tab
              value={"0"}
              label={
                <Typography
                  variant="subtitle2"
                  owner="admin"
                  notransform="true"
                >
                  Users
                </Typography>
              }
            />

            <Tab
              value={"1"}
              label={
                <Typography
                  variant="subtitle2"
                  owner="admin"
                  notransform="true"
                >
                  Categories
                </Typography>
              }
            />

            <Tab
              value={"2"}
              label={
                <Typography
                  variant="subtitle2"
                  owner="admin"
                  notransform="true"
                >
                  Roles
                </Typography>
              }
            />

            <Tab
              value={"3"}
              label={
                <Typography
                  variant="subtitle2"
                  owner="admin"
                  notransform="true"
                >
                  Send to all
                </Typography>
              }
              onClick={() => handleToAll()}
            />
          </Tabs>
        </Col>
      </Row>
    );
  };

  // Pagination component
  const renderPagination = () => {
    if (totalItems <= pageSize) {
      return null;
    } else {
      return (
        <Pagination
          owner="admin"
          containerClasses={`creator-pagination d-flex justify-content-center align-items-center mt-4`}
          previousDisabled={currentPage === 0 ? true : false}
          nextDisabled={currentPage + 1 === totalPages}
          currentPage={currentPage + 1}
          onPrevious={() => {
            setCurrentPage((prev) => Math.max(prev - 1, 0));
          }}
          onNext={() => {
            setCurrentPage((prev) => Math.max(prev + 1, 0));
          }}
        />
      );
    }
  };

  const renderNotificationListPagination = () => {
    if (totalNotificationsItems <= pageSize) {
      return null;
    } else {
      return (
        <Pagination
          owner="admin"
          containerClasses={`creator-pagination d-flex justify-content-center align-items-center mt-4`}
          previousDisabled={currentNotificationsPage === 0 ? true : false}
          nextDisabled={currentNotificationsPage + 1 === totalNotificationPages}
          currentPage={currentNotificationsPage + 1}
          onPrevious={() => {
            setCurrentNotificationsPage((prev) => Math.max(prev - 1, 0));
          }}
          onNext={() => {
            setCurrentNotificationsPage((prev) => Math.max(prev + 1, 0));
          }}
        />
      );
    }
  };

  const userFilters = () => {
    return (
      <Row className="filter-container w-100 align-items-end mb-2">
        <Col xs={12} sm={6} md={4} className="filter-item mb-3">
          <FormControl fullWidth size="small">
            <TextField
              id="uid"
              label="UID"
              variant={input_variant}
              value={uid}
              size="small"
              placeholder="User ID"
              onChange={(event) => {
                // event.target.value
                setUid(event.target.value);
              }}
              InputProps={{
                style: { fontSize: input_font_size },
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchOutlined
                      sx={{
                        width: "20px",
                        height: "18px",
                      }}
                    />
                  </InputAdornment>
                ),
              }}
              InputLabelProps={{
                style: { fontSize: input_font_size },
              }}
              owner="admin"
              sub_variant="presentation-filter"
            />
          </FormControl>
        </Col>

        <Col xs={12} sm={6} md={4} className="filter-item mb-3">
          <FormControl fullWidth size="small">
            <TextField
              id="username"
              label="Username"
              variant={input_variant}
              value={username}
              size="small"
              placeholder="Username"
              onChange={(event) => {
                // event.target.value
                setUsername(event.target.value);
              }}
              InputProps={{
                style: { fontSize: input_font_size },
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchOutlined
                      sx={{
                        width: "20px",
                        height: "18px",
                      }}
                    />
                  </InputAdornment>
                ),
              }}
              InputLabelProps={{
                style: { fontSize: input_font_size },
              }}
              owner="admin"
              sub_variant="presentation-filter"
            />
          </FormControl>
        </Col>

        <Col xs={12} sm={6} md={4} className="filter-item mb-3">
          <FormControl fullWidth size="small">
            <TextField
              id="email"
              label="Email"
              variant={input_variant}
              value={email}
              size="small"
              placeholder="Email"
              onChange={(event) => {
                // event.target.value
                setEmail(event.target.value);
              }}
              InputProps={{
                style: { fontSize: input_font_size },
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchOutlined
                      sx={{
                        width: "20px",
                        height: "18px",
                      }}
                    />
                  </InputAdornment>
                ),
              }}
              InputLabelProps={{
                style: { fontSize: input_font_size },
              }}
              owner="admin"
              sub_variant="presentation-filter"
            />
          </FormControl>
        </Col>

        <Col xs={12} sm={6} md={4} className="filter-item mb-3">
          <FormControl
            fullWidth
            size="small"
            sx={{ backgroundColor: "primary.light" }}
          >
            <InputLabel
              sx={{
                fontSize: input_font_size,
                color: "rgba(0, 0, 0, 0.87)",
              }}
              size="small"
              id="roles-select-label"
            >
              Role
            </InputLabel>
            <Select
              labelId="roles-select-label"
              id="roles-select"
              value={rolesFilter} // Bind to the roles in the filters object
              multiple
              label="Role"
              onChange={(event) => {
                const selectedRoles = event.target.value;

                // Logic to handle "All roles" selection
                if (selectedRoles.includes("all")) {
                  if (selectedRoles[0] === "all" && selectedRoles.length > 1) {
                    selectedRoles.shift();
                  }
                  setRolesFilter(
                    selectedRoles.includes("all") ? ["all"] : selectedRoles
                  );
                } else {
                  setRolesFilter(selectedRoles);
                }
              }}
              renderValue={(selected) => selected.join(", ")}
              input={
                input_variant === "outlined" ? (
                  <OutlinedInput
                    owner="admin"
                    sub_variant="presentation-filter"
                    sx={{
                      fontSize: input_font_size,
                    }}
                    label="Role"
                  />
                ) : (
                  <Input
                    sx={{
                      fontSize: input_font_size,
                      color: "red",
                    }}
                    label="Role"
                  />
                )
              }
            >
              {roles.map((role, index) => (
                <MenuItem
                  key={`roles-${index}`}
                  value={role.id}
                  disabled={
                    roles.includes("all") && role.id !== "all" // Disable other roles if "All roles" is selected
                  }
                >
                  <Checkbox
                    size="small"
                    checked={rolesFilter.indexOf(role.id) > -1}
                    sx={{
                      marginLeft: "-10px",
                      padding: "5px",
                    }}
                  />
                  <ListItemText
                    disableTypography
                    primary={
                      <Typography style={{ fontSize: input_font_size }}>
                        {role.label}
                      </Typography>
                    }
                  />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Col>

        <Col xs={12} sm={6} md={4} className="filter-item mb-3">
          <FormControl
            fullWidth
            size="small"
            sx={{ backgroundColor: "primary.light" }}
          >
            <InputLabel
              sx={{
                fontSize: input_font_size,
                color: "rgba(0, 0, 0, 0.87)",
              }}
              size="small"
              id="roles-select-label"
            >
              Category
            </InputLabel>
            <Select
              labelId="category-select-label"
              id="category-select"
              value={categoriesFilter} // Bind to the roles in the filters object
              multiple
              label="Role"
              onChange={(event) => {
                const selectedCategories = event.target.value;
                // Logic to handle "All roles" selection
                if (selectedCategories.includes("all")) {
                  if (
                    selectedCategories[0] === "all" &&
                    selectedCategories.length > 1
                  ) {
                    selectedCategories.shift();
                  }
                  setCategoriesFilter(
                    selectedCategories.includes("all")
                      ? ["all"]
                      : selectedCategories
                  );
                } else {
                  setCategoriesFilter(selectedCategories);
                }
              }}
              renderValue={(selected) => selected.join(", ")}
              input={
                input_variant === "outlined" ? (
                  <OutlinedInput
                    owner="admin"
                    sub_variant="presentation-filter"
                    sx={{
                      fontSize: input_font_size,
                    }}
                    label="Category"
                  />
                ) : (
                  <Input
                    sx={{
                      fontSize: input_font_size,
                      color: "red",
                    }}
                    label="Category"
                  />
                )
              }
            >
              {categories.map((category, index) => (
                <MenuItem
                  key={`category-${index}`}
                  value={category.id}
                  disabled={
                    categories.includes("all") && category.id !== "all" // Disable other roles if "All roles" is selected
                  }
                >
                  <Checkbox
                    size="small"
                    checked={categoriesFilter.indexOf(category.id) > -1}
                    sx={{
                      marginLeft: "-10px",
                      padding: "5px",
                    }}
                  />
                  <ListItemText
                    disableTypography
                    primary={
                      <Typography style={{ fontSize: input_font_size }}>
                        {category.label}
                      </Typography>
                    }
                  />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Col>

        <Col xs={12} sm={12} md={4} className="filter-item mb-3 align-self-end">
          <Stack
            direction="row"
            spacing={2}
            justifyContent="flex-end"
            alignItems="flex-end"
          >
            <FormControl className="btn" fullWidth>
              <Button variant="outlined" onClick={onReset}>
                <Typography owner="admin" variant="button" className="lh">
                  Reset
                </Typography>
              </Button>
            </FormControl>
            <FormControl className="btn" fullWidth>
              <Button
                type="submit"
                sx={{ fontSize: input_font_size }}
                variant="contained"
                onClick={onApply}
              >
                <Typography owner="admin" variant="button" className="lh">
                  Apply
                </Typography>
              </Button>
            </FormControl>
          </Stack>
        </Col>
      </Row>
    );
  };

  const ColumnHeader = ({ children }) => {
    return (
      <Typography owner="admin" variant="subtitle2">
        {children}
      </Typography>
    );
  };

  const CellContainer = ({ children }) => {
    return <TableCell className="py-1 px-1">{children}</TableCell>;
  };

  const CellText = ({ children }) => {
    return (
      <Typography owner="admin" variant="body2" lh="medium">
        {children}
      </Typography>
    );
  };

  const usersTab = () => {
    return (
      <>
        {userFilters()}
        {data.users && data.users.length > 0 ? (
          <Row>
            <TableContainer component={Box}>
              <Table size="small">
                <TableHead className="table-header">
                  <TableRow>
                    <CellContainer>
                      <ColumnHeader>Select</ColumnHeader>
                    </CellContainer>
                    <CellContainer>
                      <ColumnHeader>UID</ColumnHeader>
                    </CellContainer>
                    <CellContainer>
                      <ColumnHeader>Username/Email</ColumnHeader>
                    </CellContainer>
                    <CellContainer>
                      <ColumnHeader>Category</ColumnHeader>
                    </CellContainer>
                    <CellContainer>
                      <ColumnHeader>Roles</ColumnHeader>
                    </CellContainer>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.users.map((row) => (
                    <TableRow key={row.id}>
                      <CellContainer className="py-2">
                        <Checkbox
                          checked={selectedTokens[row.type]?.includes(row.id)}
                          onChange={(e) => handleToggle(row, e.target.checked)}
                        />
                      </CellContainer>
                      <CellContainer className="py-2">
                        <CellText>{row.id}</CellText>
                      </CellContainer>
                      <CellContainer className="py-2">
                        <Row className="gx-0">
                          <Col>
                            <Row className="gx-0">
                              <CellText>{row.username ?? ""}</CellText>
                            </Row>
                            <Row className="gx-0">
                              <CellText>{row.email ?? ""}</CellText>
                            </Row>
                          </Col>
                        </Row>
                      </CellContainer>
                      <CellContainer>
                        <CellText>{row.category?.label ?? ""}</CellText>
                      </CellContainer>
                      <CellContainer className="py-2">
                        <Tooltip
                          title={
                            <Box>
                              {row.roles.map((role, idx) => (
                                <div key={idx}>{role}</div>
                              ))}
                            </Box>
                          }
                          placement="right"
                        >
                          <IconButton size="small" color="adminText">
                            <InfoOutlinedIcon fontSize="inherit" />
                          </IconButton>
                        </Tooltip>
                      </CellContainer>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            {renderPagination()}
          </Row>
        ) : (
          <NoData />
        )}
      </>
    );
  };

  const categoriesTab = () => {
    return (
      <>
        {data.categories && data.categories.length > 0 ? (
          <TableContainer component={Box}>
            <Table>
              <TableHead className="table-header">
                <TableRow>
                  <CellContainer>
                    <ColumnHeader>Select</ColumnHeader>
                  </CellContainer>
                  <CellContainer>
                    <ColumnHeader>Name</ColumnHeader>
                  </CellContainer>
                  <CellContainer>
                    <ColumnHeader>No. of devices</ColumnHeader>
                  </CellContainer>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.categories.map((row) => (
                  <TableRow key={row.id}>
                    <CellContainer>
                      <Checkbox
                        className="py-0"
                        checked={selectedTokens[row.type]?.includes(row.id)}
                        onChange={(e) => handleToggle(row, e.target.checked)}
                      />
                    </CellContainer>
                    <CellContainer>
                      <CellText>{row.label}</CellText>
                    </CellContainer>
                    <CellContainer>
                      <CellText>{row.count}</CellText>
                    </CellContainer>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <NoData />
        )}
      </>
    );
  };

  const rolesTab = () => {
    return (
      <>
        {data.roles && data.roles.length > 0 ? (
          <TableContainer component={Box}>
            <Table>
              <TableHead className="table-header">
                <TableRow>
                  <CellContainer>
                    <ColumnHeader>Select</ColumnHeader>
                  </CellContainer>
                  <CellContainer>
                    <ColumnHeader>Name</ColumnHeader>
                  </CellContainer>
                  <CellContainer>
                    <ColumnHeader>No. of devices</ColumnHeader>
                  </CellContainer>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.roles.map((row) => (
                  <TableRow key={row.id}>
                    <CellContainer>
                      <Checkbox
                        className="py-0"
                        checked={selectedTokens[row.type]?.includes(row.id)}
                        onChange={(e) => handleToggle(row, e.target.checked)}
                      />
                    </CellContainer>
                    <CellContainer>
                      <Typography owner="admin" variant="subtitle1">
                        {row.label}
                      </Typography>
                    </CellContainer>
                    <CellContainer>
                      <Typography owner="admin" variant="subtitle1">
                        {row.count}
                      </Typography>
                    </CellContainer>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <NoData />
        )}
      </>
    );
  };

  const selectionColumn = () => {
    return (
      <Col xs={12} xxl={5} className="d-flex flex-column mt-xxl-0 mt-5">
        <Row>
          <Col xs={6} className="d-flex align-items-end">
            <Typography
              owner="client"
              variant="h5"
              color="clientText.main"
              lh="wide"
              weight="bold"
            >
              Selected
            </Typography>
          </Col>
          <Col xs={6} className="text-end d-flex flex-column">
            <Row className="h-100">
              <Box
                style={{
                  justifyContent: "end",
                  display: "flex",
                }}
              >
                <Button
                  owner="admin"
                  variant="outlined"
                  onClick={handleClear}
                  sx={{ marginRight: "10px" }}
                >
                  <Typography owner="admin" variant="button">
                    Clear
                  </Typography>
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => setOpen(true)}
                  disabled={
                    !selectedTokens.categories.length &&
                    !selectedTokens.roles.length &&
                    !selectedTokens.users.length &&
                    !toAll
                  }
                >
                  <Typography owner="admin" variant="button">
                    Create message
                  </Typography>
                </Button>
              </Box>
            </Row>
          </Col>
        </Row>
        <Row className="flex-grow-1">
          <Col xs={12} className="d-flex flex-column">
            <Row className="flex-grow-1 gx-0 mt-2">
              <Col className="selected-container mt-3 px-4 pt-2 pb-4">
                {renderSelection()}
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    );
  };

  const renderSelection = () => {
    const renderText = (type, item) => {
      if (type === "users") {
        return `• ${item.username ?? ""} (${item.id}), ${item.email}`;
      } else {
        const label = item.count > 1 ? "devices" : "device";
        return `• ${item.label} (${item.count} ${label})`;
      }
    };

    if (toAll) {
      return (
        <Box className="mt-4 w-100 h-100 d-flex justify-content-center">
          <Typography
            className="text-center"
            owner="admin"
            variant="body2"
            lh="medium"
          >
            You have selected to send a push notification to all users, in all
            roles and categories. Click the ‘Create message’ button to continue.
          </Typography>
        </Box>
      );
    } else {
      return (
        <>
          {Object.entries(selectedTokens).map(([type, ids]) => {
            if (!ids.length) return null;

            // Get full objects by matching IDs
            const selectedItems = data[type].filter((item) =>
              ids.includes(item.id)
            );

            return (
              <Box key={type} sx={{ mt: 2 }}>
                <Typography
                  className="mb-1"
                  owner="admin"
                  variant="subtitle2"
                  sx={{ fontWeight: 600 }}
                  lh="medium"
                >
                  {type.charAt(0).toUpperCase() + type.slice(1)}
                </Typography>

                {selectedItems.map((item) => (
                  <Typography
                    key={item.id}
                    owner="admin"
                    variant="body2"
                    lh="medium"
                  >
                    {renderText(type, item)}
                  </Typography>
                ))}
              </Box>
            );
          })}
        </>
      );
    }
  };

  const pushPrompt = () => {
    const confirmLabel = pushSuccess ? "DONE" : "OK";
    const severity = pushSuccess ? "success" : pushError ? "error" : "";
    return (
      <Row className="push-prompt-container">
        <Col>
          <Box
            className="d-flex h-100 justify-content-center align-items-center align-content-center"
            sx={{ flexDirection: "column" }}
          >
            <Alert
              variant="filled"
              severity={severity}
              action={
                <Button
                  color="inherit"
                  size="small"
                  onClick={() => {
                    if (pushSuccess) {
                      setPushSuccess(null);
                    }
                    if (pushError) {
                      setPushError(null);
                    }
                  }}
                >
                  {confirmLabel}
                </Button>
              }
            >
              {pushSuccess}
            </Alert>
          </Box>
        </Col>
      </Row>
    );
  };

  const getUrlValue = () => {
    let path = "";

    if (screen || nid) {
      path = linkGenerator(screen, nid);
    }

    return path;
  };

  return (
    <>
      {isLoading ? (
        <div className="circular-container fs">
          <CompanyappLoader />
        </div>
      ) : (
        <>
          {isError ? (
            <Row className="h-100 justify-content-center align-self-center">
              <Col>
                <Box
                  className="d-flex h-100 justify-content-center align-items-center align-content-center"
                  sx={{ flexDirection: "column" }}
                >
                  <Alert variant="filled" severity="error">
                    {errorStatus ? `${errorStatus} - ` : ""}
                    {errorMessage}
                  </Alert>
                </Box>
              </Col>
            </Row>
          ) : (
            <main className="tokens screen d-flex flex-column justify-content-between mx-lg-auto">
              {renderHeader()}
              {activeView === 0 && (
                <>
                  {isSearching ? (
                    <div className="circular-container fs">
                      <CompanyappLoader />
                    </div>
                  ) : (
                    <>
                      {(pushError || pushSuccess) && pushPrompt()}

                      <Row>
                        <Col xs={12} xxl={7} className="pe-4">
                          {renderTabs()}

                          <Row className="mt-3">
                            {selectedType === "0" && usersTab()}

                            {selectedType === "1" && categoriesTab()}

                            {selectedType === "2" && rolesTab()}
                          </Row>
                        </Col>

                        {selectionColumn()}
                      </Row>
                    </>
                  )}
                </>
              )}

              {activeView === 1 && (
                <>
                  {notificationsLoading ? (
                    <CompanyappLoader />
                  ) : (
                    <>
                      {notificationsError ? (
                        <Row className="h-100 justify-content-center align-self-center">
                          <Col>
                            <Box
                              className="d-flex h-100 justify-content-center align-items-center align-content-center"
                              sx={{ flexDirection: "column" }}
                            >
                              <Alert variant="filled" severity="error">
                                Error loading notifications
                              </Alert>
                            </Box>
                          </Col>
                        </Row>
                      ) : (
                        <>
                          {notifications && notifications.length > 0 ? (
                            <Row>
                              <TableContainer component={Box}>
                                <Table size="small">
                                  <TableHead className="table-header">
                                    <TableRow>
                                      <CellContainer>
                                        <ColumnHeader>Title</ColumnHeader>
                                      </CellContainer>
                                      <CellContainer>
                                        <ColumnHeader>Body</ColumnHeader>
                                      </CellContainer>
                                      <CellContainer>
                                        <ColumnHeader>Success</ColumnHeader>
                                      </CellContainer>
                                      <CellContainer>
                                        <ColumnHeader>Failures</ColumnHeader>
                                      </CellContainer>
                                      <CellContainer>
                                        <ColumnHeader>Date</ColumnHeader>
                                      </CellContainer>
                                      <CellContainer>
                                        <ColumnHeader>Actions</ColumnHeader>
                                      </CellContainer>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {notifications.map((row) => (
                                      <TableRow key={row.id}>
                                        {/* Title */}
                                        <CellContainer className="py-2">
                                          <CellText>{row.title ?? ""}</CellText>
                                        </CellContainer>

                                        {/* Body */}
                                        <CellContainer className="py-2">
                                          <CellText>{row.body ?? ""}</CellText>
                                        </CellContainer>

                                        {/* Success */}
                                        <CellContainer className="py-2">
                                          <CellText>
                                            {row.success_count ?? 0}
                                          </CellText>
                                        </CellContainer>

                                        {/* Failures */}
                                        <CellContainer className="py-2">
                                          <CellText>
                                            {row.failure_count ?? 0}
                                          </CellText>
                                        </CellContainer>

                                        {/* Date */}
                                        <CellContainer className="py-2">
                                          <CellText>
                                            {row.created
                                              ? new Date(
                                                  // handle both seconds and milliseconds
                                                  row.created.toString()
                                                    .length === 10
                                                    ? row.created * 1000
                                                    : row.created
                                                ).toLocaleString()
                                              : ""}
                                          </CellText>
                                        </CellContainer>

                                        {/* Actions */}
                                        <CellContainer className="py-2">
                                          <CellText>
                                            <Button
                                              variant="outline"
                                              color="primary"
                                              onClick={() => {
                                                setSelectedNotification(row);
                                                setNotificationDialog(true);
                                              }}
                                            >
                                              More info
                                            </Button>
                                          </CellText>
                                        </CellContainer>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                              {renderNotificationListPagination()}
                            </Row>
                          ) : (
                            <NoData />
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}

              {/* Modal for Send Notification */}
              <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
                <DialogTitle>Send Notification</DialogTitle>
                <DialogContent>
                  <TextField
                    fullWidth
                    label="Title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    margin="normal"
                  />
                  <TextField
                    fullWidth
                    label="Body"
                    value={body}
                    onChange={(e) => setBody(e.target.value)}
                    margin="normal"
                    multiline
                    rows={3}
                  />
                  <Typography variant="h6" marginTop={2} marginBottom={2}>
                    Payload
                  </Typography>

                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} marginBottom={2}>
                      <TextField
                        label="Node ID"
                        fullWidth
                        value={nid}
                        onChange={(e) => setNid(e.target.value)}
                        helperText="The ID of the content you want to link to"
                      />
                    </Grid>

                    <Grid item xs={12} marginBottom={2}>
                      <Autocomplete
                        freeSolo
                        options={screenOptions}
                        getOptionLabel={(option) =>
                          typeof option === "string" ? option : option.label
                        }
                        value={
                          screenOptions.find((opt) => opt.value === screen) ||
                          screen
                        }
                        onChange={(event, newValue) => {
                          if (typeof newValue === "string") {
                            setScreen(newValue);
                          } else if (newValue?.value) {
                            setScreen(newValue.value);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Screen" fullWidth />
                        )}
                        helperText="The screen you want to link to"
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      marginBottom={2}
                      sx={{ display: "none" }}
                    >
                      <TextField
                        label="URL"
                        fullWidth
                        value={url}
                        // disabled
                      />
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions sx={{ mr: 2, mb: 2 }}>
                  <Button
                    owner="admin"
                    variant="outlined"
                    onClick={() => setOpen(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleSend}
                    color="secondary"
                    variant="contained"
                    disabled={title.length < 1 || body.length < 1}
                  >
                    {pushSending ? (
                      <span>
                        <span style={{ visibility: "hidden" }}>
                          Send Notification
                        </span>
                        <CircularProgress
                          size={20}
                          sx={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            margin: "auto",
                          }}
                        />
                      </span>
                    ) : (
                      "Send Notification"
                    )}
                  </Button>
                </DialogActions>
              </Dialog>

              {/* Modal for View Notification */}
              <Dialog
                open={notificationDialog}
                onClose={() => setNotificationDialog(false)}
                fullWidth
              >
                <DialogTitle>Notification Details</DialogTitle>
                {selectedNotification && (
                  <DialogContent dividers>
                    <Grid container spacing={2}>
                      {/* Title & Body */}
                      <Grid item xs={12}>
                        <Typography variant="h6">Title</Typography>
                        <Typography>{selectedNotification.title}</Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="h6">Body</Typography>
                        <Typography>{selectedNotification.body}</Typography>
                      </Grid>

                      {/* Payload */}
                      {selectedNotification.payload &&
                        selectedNotification.payload.length > 0 && (
                          <Grid item xs={12}>
                            <Typography variant="h6">Payload</Typography>
                            {selectedNotification.payload.map((p, index) => (
                              <pre key={index}>
                                {JSON.stringify(
                                  selectedNotification.payload,
                                  null,
                                  2
                                )}
                              </pre>
                            ))}
                          </Grid>
                        )}

                      {/* Send Type */}
                      {selectedNotification.sendType &&
                        selectedNotification.sendType.length > 0 && (
                          <Grid item xs={12}>
                            <Typography variant="h6">Sent to</Typography>
                            <Typography></Typography>

                            {selectedNotification.sendType.map((type, idx) => (
                              // <Chip
                              //   key={idx}
                              //   label={type.label}
                              //   color="primary"
                              // />
                              <React.Fragment key={idx}>
                                {`${type.label}, `}
                              </React.Fragment>
                            ))}
                          </Grid>
                        )}

                      {/* Roles */}
                      {selectedNotification.roles &&
                        selectedNotification.roles.length > 0 && (
                          <Grid item xs={12}>
                            <Typography variant="h6">Roles</Typography>
                            <Stack
                              direction="column"
                              spacing={1}
                              flexWrap="wrap"
                            >
                              {selectedNotification.roles.map((role) => (
                                <Typography key={role.id}>
                                  - {role.label}
                                </Typography>
                              ))}
                            </Stack>
                          </Grid>
                        )}

                      {/* Categories */}
                      {selectedNotification.categories &&
                        selectedNotification.categories.length > 0 && (
                          <Grid item xs={12}>
                            <Typography variant="h6">Categories</Typography>
                            <Stack
                              direction="column"
                              spacing={1}
                              flexWrap="wrap"
                            >
                              {selectedNotification.categories.map(
                                (cat, idx) => {
                                  const label = Array.isArray(cat.label)
                                    ? cat.label[0]?.value
                                    : cat.label;
                                  return (
                                    <Typography key={idx}>- {label}</Typography>
                                  );
                                }
                              )}
                            </Stack>
                          </Grid>
                        )}

                      {/* Users */}
                      {selectedNotification.users &&
                        selectedNotification.users.length > 0 && (
                          <Grid item xs={12}>
                            <Typography variant="h6">Users</Typography>
                            <Stack direction="column" spacing={0.5}>
                              {selectedNotification.users.map((user) => (
                                <Typography key={user.id}>
                                  - {user.firstName} {user.lastName} (
                                  {user.email})
                                </Typography>
                              ))}
                            </Stack>
                          </Grid>
                        )}
                    </Grid>
                  </DialogContent>
                )}
                <DialogActions sx={{ mr: 2, mb: 2 }}>
                  <Button
                    owner="admin"
                    variant="outlined"
                    onClick={() => setNotificationDialog(false)}
                  >
                    Close
                  </Button>
                </DialogActions>
              </Dialog>
            </main>
          )}
        </>
      )}
    </>
  );
}
